import React, { useEffect, useState } from "react";
import { useAuth } from "../../../context/AuthContext";
import { useProtectedRoute } from "../../../hooks/useProtectedRoute";
import { useNavigate } from "react-router-dom";
import api from "../../../services/api";
import SupplierTable from "../components/SupplierTable";

type Supplier = {
  _id: string;
  name: string;
  email?: string;
  phone?: string;
  address?: string;
  contactPerson?: string;
};

const SuppliersListPage: React.FC = () => {
  useProtectedRoute();
  const { token } = useAuth();
  const [suppliers, setSuppliers] = useState<Supplier[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    setError(null);
    api.get("/inventory/suppliers/all", {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => setSuppliers(res.data))
      .catch(() => setError("Failed to load suppliers"))
      .finally(() => setLoading(false));
  }, [token]);

  return (
    <div className="max-w-4xl mx-auto p-4">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-bold">Suppliers</h1>
        <button
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          aria-label="Add new supplier"
          onClick={() => navigate("/suppliers/add")}
        >
          + Add Supplier
        </button>
      </div>
      {error && <div className="text-red-600 mb-2">{error}</div>}
      <SupplierTable
        suppliers={suppliers}
        loading={loading}
        onEdit={id => navigate(`/suppliers/${id}/edit`)}
      />
    </div>
  );
};

export default SuppliersListPage;
